function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 135 135",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-632.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard1",
    transform: "matrix(0.177353,0,0,1.28554,0,632.944)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 761.192,
    height: 105.015,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.81864,0,0,0.664782,-897.215,-224.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.861,419.959C232.861,419.959 241.334,425.046 249.876,430.175C261.32,437.046 275.456,437.689 287.476,431.885C298.738,426.432 311.754,419.162 318.045,412.072C318.047,412.074 318.064,412.071 318.093,412.063C320.684,411.674 323.237,412.972 324.449,415.295C325.661,417.619 325.264,420.455 323.462,422.357C323.584,422.577 323.555,422.605 323.549,422.605C318.49,431.925 315.124,445.157 315.827,460.24C315.827,469.595 311.736,477.772 304.837,482.153C304.837,482.153 304.836,482.153 304.836,482.154C298.156,486.397 289.472,485.697 283.557,480.439C280.902,478.079 278.026,475.522 275.446,473.23C270.868,469.16 263.966,469.169 259.399,473.251C256.857,475.523 254.024,478.054 251.4,480.399C245.459,485.709 236.712,486.423 229.989,482.146C229.99,482.145 229.989,482.144 229.989,482.144C223.099,477.761 219.013,469.589 219.013,460.24C220.873,443.616 217.436,428.681 208.364,418.052L208.364,418.052C203.062,410.997 199.92,402.233 199.92,392.74C199.92,381.617 204.233,371.495 211.277,363.954C211.663,363.542 212.051,363.125 212.442,362.706C221.856,352.618 237.168,350.78 248.702,358.353C252.018,360.427 255.337,362.498 258.29,364.378C263.781,368.192 271.062,368.201 276.562,364.401C279.765,362.379 283.392,360.142 286.985,357.952C297.884,350.891 312.251,352.497 321.323,361.79C321.436,361.873 321.532,361.972 321.628,362.07C329.411,370.042 332.656,381.398 330.261,392.279C330.26,392.279 330.26,392.279 330.26,392.279",
    style: {
      fill: "none",
      stroke: "url(#_Linear1)",
      strokeWidth: "17.31px"
    }
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(139.883,0,0,142.868,199.92,417.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(165,36,182)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(255,13,191)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.3ad6a35bbbc62eb0fabb39b3c759d260.svg";
export { ForwardRef as ReactComponent };